import { render, staticRenderFns } from "./TopMenuForCustomer.vue?vue&type=template&id=19c0c626&scoped=true"
import script from "./TopMenuForCustomer.vue?vue&type=script&lang=js"
export * from "./TopMenuForCustomer.vue?vue&type=script&lang=js"
import style0 from "./TopMenuForCustomer.vue?vue&type=style&index=0&id=19c0c626&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c0c626",
  null
  
)

export default component.exports